<template>
  <v-container fluid class="fill-height">
    <v-row justify="center">
      <v-col cols="12">
        <v-card
            class="mx-auto"
            max-width="512"
            elevation="12"
            :loading="isLoading"
        >
          <v-card-title>
            ¿Olvidaste tu contraseña?
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text>
            <p class="subtitle-1">
              Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña. Tienes 1 hora para
              realizar el proceso.</p>
            <v-form
                ref="forgotPasswordForm"
                v-model="isValidForm"
                lazy-validation
            >
              <v-text-field
                  v-model="email"
                  label="Dirección de correo electrónico"
                  type="email"
                  required
                  :rules="[rules.required, rules.email]"
                  prepend-inner-icon="mdi-email-outline"
              />
              <v-alert
                  type="info"
                  color="green"
                  class="mt-4"
                  border="left"
                  dense
                  outlined
                  v-if="emailSent && remainingCooldown > 0"
              >
                Si no recibes el correo, revisa tu carpeta de spam o intenta nuevamente en {{ remainingCooldown }}
                segundos.
              </v-alert>
            </v-form>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-row>
              <v-col cols="12" sm="6" order="last" order-sm="first">
                <v-btn
                    color="secondary"
                    @click="$router.push('/inicio-de-sesion')"
                    block
                >
                  <v-icon left>mdi-close</v-icon>
                  Cancelar
                </v-btn>
              </v-col>
              <v-col cols="12" sm="6" order="first" order-sm="last">
                <v-btn
                    color="primary"
                    @click="requestForgotPassword"
                    :loading="isLoading"
                    :disabled="!isValidForm || remainingCooldown > 0"
                    block
                >
                  <v-icon left>mdi-email-fast</v-icon>
                  {{ emailSent ? 'Reenviar correo' : 'Enviar correo' }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import ReturnButton from "@/components/buttons/ReturnButton.vue";
import AuthService from "@/services/auth/AuthService";
import throwSuccessMessage from "@/utils/SuccessMessage";

export default Vue.extend({
  name: 'ForgotPassword',
  components: {ReturnButton},
  data() {
    return {
      // Form data
      email: '',

      // State
      isValidForm: false,
      isLoading: false,
      emailSent: false,
      remainingCooldown: 0,
      cooldownTime: 60,
      timerInterval: null as number | null,

      // Validation
      rules: {
        required: (value: string) => !!value || 'Este campo es requerido.',
        email: (value: string) => {
          const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return pattern.test(value) || 'Ingresa un correo electrónico válido.';
        }
      }
    }
  },
  methods: {
    async requestForgotPassword() {
      const form = this.$refs.forgotPasswordForm as any;
      if (!form.validate()) return;
      this.isLoading = true;
      try {
        const body = {
          email: this.email,
        }
        await AuthService.forgotPassword(body);
        this.emailSent = true;
        throwSuccessMessage('Correo enviado. Si el correo existe en el sistema, recibirás un enlace para restablecer tu contraseña.');
      } finally {
        this.isLoading = false;
        this.startCooldown();
      }
    },
    startCooldown() {
      this.remainingCooldown = this.cooldownTime;
      if (this.timerInterval) {
        window.clearInterval(this.timerInterval);
      }

      this.timerInterval = window.setInterval(() => {
        this.remainingCooldown--;
        if (this.remainingCooldown <= 0) {
          if (this.timerInterval) {
            window.clearInterval(this.timerInterval);
            this.timerInterval = null;
          }
        }
      }, 1000);
    }
  },

  beforeDestroy() {
    if (this.timerInterval) {
      window.clearInterval(this.timerInterval);
    }
  }
})
</script>

<style scoped>

</style>